import { Firestore } from "../lib/firebase";

const MAIL_TABLE_NAME = "mail";

export function sendEmail(sender, recipients, subject, message) {
  return Firestore.collection(MAIL_TABLE_NAME)
    .add({
      from: `${sender} <info@hackyourcloset.com>`,
      to: recipients,
      message: {
        subject,
        html: message,
      },
    })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
}
